<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Dados Gerais"
      >
        <NxInputDocument
          @update:value="handleInputUpdate('document', $event)"
        />
        <NxInputName @update:value="handleInputUpdate('nome', $event, false)" />
        <NxInput
          name="numProtocolo"
          type="text"
          label="Número do Protocolo:"
          placeholder="Digite o Número do Protocolo:"
          @update:value="handleInputUpdate('numProtocolo', $event, false)"
        ></NxInput>
      </SearchCollapse>

      <SearchCollapse title="Instituição">
        <NxSelectPA @update:value="handleSelectUpdate('paIds', $event)" />
        <NxSelectRegional
          @update:value="handleSelectUpdate('nomeRegional', $event)"
        />
        <NxSelectFuncionario
          :variable="employeeTypes.GERENTE"
          @update:value="handleSelectUpdate('gerenteId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Responsável">
        <NxSelectFuncionario
          :variable="employeeTypes.RESPONSAVEL"
          @update:value="handleSelectUpdate('responsavelId', $event)"
        />
        <NxSelectResponsavelGrupo
          @update:value="handleSelectUpdate('gruposResponsaveisId', $event)"
        />
      </SearchCollapse>

      <SearchCollapse title="Produto">
        <NxSelectProduto
          @update:value="handleSelectUpdate('produtosId', $event)"
        />
        <NxInputMoneyRange
          @update:InitialValue="
            handleInputUpdate('valorInicial', $event, false)
          "
          @update:FinalValue="handleInputUpdate('valorFinal', $event, false)"
        />
      </SearchCollapse>
      <SearchCollapse title="Geral">
        <NxSelectQuadro @update:value="handleSelectUpdate('boardId', $event)" />
        <!-- ORIGEM AND SITUACAO ARE NOT MADE -->
        <NxSelectOrigem
          @update:value="handleSelectUpdate('origensId', $event)"
        />
        <NxSelectSituacao
          @update:value="handleSelectUpdate('situacao', $event)"
        />
        <NxInputDateRange
          label="Data de Abertura Oportunidade:"
          @update:InitialValue="
            handleInputDateUpdate('dataAberturaInicial', $event, false)
          "
          @update:FinalValue="handleInputDateUpdate('dataAberturaFinal', $event, false)"
        />
        <NxInputDateRange
          label="Data de Fechamento Oportunidade:"
          @update:InitialValue="
            handleInputDateUpdate('dataFechamentoInicial', $event, false)
          "
          @update:FinalValue="handleInputDateUpdate('dataFechamentoFinal', $event, false)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import {
  NxInputDateRange,
  NxInputDocument,
  NxInputMoneyRange,
  NxInputName,
  NxInputNumberRange
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectFuncionario,
  NxSelectOrigem,
  NxSelectPA,
  NxSelectProduto,
  NxSelectQuadro,
  NxSelectRegional,
  NxSelectResponsavelGrupo,
  NxSelectSituacao
} from '@/components/nexum/components/custom-selects/index.js'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import employeeTypes from '@/enums/enumEmployeeTypes.js'
import riskTypes from '@/enums/enumRiskTypes.js'

export default {
  name: 'SidebarQuadro',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectPA,
    NxSelectRegional,
    NxSelectFuncionario,
    NxSelectResponsavelGrupo,
    NxSelectProduto,
    NxSelectQuadro,
    NxSelectOrigem,
    NxSelectSituacao,
    NxInputDocument,
    NxInputName,
    NxInputMoneyRange,
    NxInputNumberRange,
    NxInputDateRange
  },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        document: null,
        paIds: null,
        nomeRegional: null,
        gerenteId: null,
        responsavelId: null,
        gruposResponsaveisId: null,
        produtosId: null,
        valorInicio: null,
        valorFinal: null,
        quadrosId: null,
        origensId: null,
        situacao: null,
        dataAberturaInicial: null,
        dataAberturaFinal: null,
        dataFechamentoInicial: null,
        dataFechamentoFinal: null,
        numProtocolo: null
      },
      riskTypes: riskTypes,
      employeeTypes: employeeTypes
    }
  },
  methods: {
    submitForm () {
      // **INÍCIO DA LÓGICA DE FORMATAÇÃO PARA ENVIO AO BACKEND**

      // 1. Formatar Documento (CPF/CNPJ): Remover máscara
      if (this.form.document) {
        // Remove todos os caracteres que não são dígitos
        this.form.document = this.form.document.toString().replace(/[^\d]+/g, '')
      }

      // 2. Formatar Valores Monetários: Remover "R$", pontos e substituir vírgula por ponto
      if (this.form.valorInicial) {
        // Garante que é string, remove "R$", pontos e substitui vírgula por ponto
        let valorInicialString = String(this.form.valorInicial)
        valorInicialString = valorInicialString.replace('R$', '').replace(/\./g, '').replace(',', '.')
        this.form.valorInicial = parseFloat(valorInicialString) // Converte para número
      }
      if (this.form.valorFinal) {
        // Garante que é string, remove "R$", pontos e substitui vírgula por ponto
        let valorFinalString = String(this.form.valorFinal)
        valorFinalString = valorFinalString.replace('R$', '').replace(/\./g, '').replace(',', '.')
        this.form.valorFinal = parseFloat(valorFinalString) // Converte para número
      }

      // **FIM DA LÓGICA DE FORMATAÇÃO PARA ENVIO AO BACKEND**

      this.$nextTick(() => {
        this.$emit('search', this.form)
        // Você está emitindo duas vezes aqui. Remova um $emit('search', this.form)
        // this.$emit('search', this.form) // <-- REMOVA ESTA LINHA DUPLICADA
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm() // Isso vai re-submeter o formulário (agora limpo)
        // Você está chamando submitForm duas vezes aqui também. Remova um.
        // console.log('🧹 Formulário limpando. Valores atuais:', JSON.parse(JSON.stringify(this.form))) // <-- ISSO É DEPOIS DO PRIMEIRO SUBMIT
        // this.submitForm() // <-- REMOVA ESTA LINHA DUPLICADA
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    encodeSpecialChar (dataPropName, value) {
      this.form[dataPropName] = encodeURIComponent(value)
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // Se o valor recebido é explicitamente nulo ou indefinido, limpa o campo.
      if (selectedValue === null || selectedValue === undefined) {
        this.clearField(fieldName)
        return
      }

      // Se o input vem como uma string ou número (para selects de valor único, como um PA se for só um número)
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = selectedValue
        return
      }

      // Se é um array (para selects múltiplos)
      if (Array.isArray(selectedValue)) {
        // Filtra qualquer valor nulo ou indefinido do array
        const cleanedValues = selectedValue.filter(v => v !== null && v !== undefined).map(v => v.hasOwnProperty('value') ? v.value : v)

        if (cleanedValues.length === 0) {
          // Se o array resultante está vazio, limpa o campo
          this.clearField(fieldName)
        } else {
          // Atribui os valores limpos
          this.form[fieldName] = cleanedValues
        }
        return
      }

      // Se é um objeto (para selects de valor único que retornam { value: ..., text: ... })
      if (typeof selectedValue === 'object' && selectedValue.hasOwnProperty('value')) {
        this.form[fieldName] = selectedValue.value
        return
      }

      // Caso fallback para limpar o campo se nenhuma das condições acima for atendida
      this.clearField(fieldName)
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = Array.isArray(inputedValue)
          ? inputedValue.map((v) => (v.hasOwnProperty('value') ? v.value : v))
          : inputedValue.hasOwnProperty('value')
            ? inputedValue.value
            : inputedValue
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputDateUpdate (fieldName, inputedValue) {
      if (inputedValue) {
        let newDate = new Date(inputedValue)
        this.form[fieldName] = newDate
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/reports/crm/search/SidebarRelatorioCrm.vue